import React from "react";
import {closePopup, getValue} from "../../../static/js/Common2";
import closeV2 from "../../../static/image/v2/popup/closeV2.png";
import {modifyOrigin} from "../../../static/js/service/shopService";

export default function MenuOriginPopupV2() {
  const modifyOriginEvent = () => {
    const shopId = document.querySelector("#originPopup .shopName").getAttribute("data-id");
    let menuOriginDesc = getValue("menuOriginDesc");

    // 문자열 길이가 10000자를 초과하면 10000자로 잘라서 전달
    if (menuOriginDesc.length > 10000) {
      menuOriginDesc = menuOriginDesc.substring(0, 10000);
    }

    modifyOrigin(shopId, menuOriginDesc);
  }

  return (
    <div>
      <div id="originPopup" className='originPopup resetPopup popupV2 hide'>
        <div className='popupContainer'>
          <div className='popupTitle'>
            <h2>원산지 수정</h2>
            <button className='closeBtn resetBtn' onClick={() => closePopup("originPopup")}>
              <img src={ closeV2 } alt='취소' />
            </button>
          </div>
          <div className='popupContent'>
            <span className='shopName' data-id='0'></span>
            <div className='popupFlexBox popupFlexBox1 popupFlexTopBox'>
              <textarea id='menuOriginDesc' placeholder='원산지 입력' />
            </div>
          </div>
          <div className='popupBtn'>
            <button type='button' className='closeBtn resetBtn' onClick={() => closePopup("originPopup")}>취소</button>
            <button type='button' className='originPopupBtn blueBtn' onClick={() => modifyOriginEvent()}>확인</button>
          </div>
        </div>
      </div>
    </div>
  )
}